<div class="ion-page" id="main-content">
  <div>
    <div
      class="or-bg-gradient or-d-flex or-justify-content-between or-align-items-start or-pb-12-px or-px-12-px or-pt-safe-top">
      <img src="assets/icons/orlikfy-header-v2.svg" alt="Orlikfy" class="or-align-self-center" style="height: 12px" />

      <ion-buttons>
        <ion-button (click)="addGame()">
          <or-icon name="plus" size="xs" boxed class="or-bg-main-1 or-color-white" />
        </ion-button>
        <ion-button (click)="openNotifications()">
          <or-icon name="notifications" size="m" class="or-color-white" />

          @if (isNewNotifications()) {
            <img src="assets/icons/unread-icon.svg" class="or-position-fixed or-bottom-16-px or-right-2-px" />
          }
        </ion-button>
      </ion-buttons>
    </div>
    @if (extended()) {
      <div class="or-bg-gradient or-h-36-px margin-top--1-px"></div>
    }
  </div>
</div>
